const button = {
    baseStyle: {
        color: "white",
    },
};
export default button;
